import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EventService {
    /**
     * Create Event
     * Send the UX event as a metric via kafka.
     * @param jobId
     * @param requestBody
     * @param includeDeleted
     * @returns any Successful Response
     * @throws ApiError
     */
    static createEvent(jobId, requestBody, includeDeleted = false) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/event',
            query: {
                'job_id': jobId,
                'include_deleted': includeDeleted,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Events
     * @param jobId
     * @returns InteractionEvent Successful Response
     * @throws ApiError
     */
    static getEvents(jobId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/event',
            query: {
                'job_id': jobId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
